export const API_CONFIGURATION_ROUTES = Object.freeze({
  CONFIGURATIONS: '/configuration',
  CONFIGURATION: '/configuration/:configurationId',
});
